import { SweetAlertOptions } from 'sweetalert2';

export const ALERT_DEFAULTS: SweetAlertOptions = {
  icon: 'error',
  title: '¡Error!',
  confirmButtonText: 'Aceptar',
  cancelButtonText: 'Cancelar',
  allowOutsideClick: true,
  customClass: {
    popup: 'bg-slate-100 text-slate-700',
    confirmButton: 'btn !bg-primary-500 text-white hover:!bg-primary-600 hover:shadow-md',
    cancelButton: 'ml-2 btn bg-white border border-slate-200 text-slate-700 hover:text-slate-800 hover:shadow-md',
    input: 'text-center',
  },
  buttonsStyling: false,
};

export const ALERT_TOAST_DEFAULTS: SweetAlertOptions = {
  position: 'top-end',
  toast: true,
  timer: 3000,
  timerProgressBar: true,
  showConfirmButton: false,
};
